import React from 'react';
import { Syringe, Calendar, AlertCircle } from 'lucide-react';
import MainTable from '../../../../../components/mainTable';
import { TableColumnsItem } from '../../../../../interfaces/components/mainTable';

interface Immunization {
  id: string;
  name: string;
  date: string;
  nextDue?: string;
  status: 'completed' | 'due' | 'overdue';
  administeredBy: string;
  lotNumber: string;
}

const mockImmunizations: Immunization[] = [
  {
    id: '1',
    name: 'COVID-19 Vaccine (Pfizer)',
    date: '2023-12-15',
    nextDue: '2024-12-15',
    status: 'completed',
    administeredBy: 'Dr. Sarah Johnson',
    lotNumber: 'PF123456'
  },
  {
    id: '2',
    name: 'Influenza Vaccine',
    date: '2023-10-01',
    nextDue: '2024-10-01',
    status: 'completed',
    administeredBy: 'Nurse Emily Brown',
    lotNumber: 'FL789012'
  },
  {
    id: '3',
    name: 'Tetanus Booster',
    date: '2022-06-15',
    nextDue: '2027-06-15',
    status: 'completed',
    administeredBy: 'Dr. Michael Chen',
    lotNumber: 'TB345678'
  },
  {
    id: '4',
    name: 'Pneumococcal Vaccine',
    date: '2023-03-01',
    nextDue: '2024-03-01',
    status: 'due',
    administeredBy: 'Nurse John Smith',
    lotNumber: 'PV901234'
  }
];

export const ImmunizationsTab: React.FC = () => {
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'completed':
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Completed
          </span>
        );
      case 'due':
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
            Due Soon
          </span>
        );
      case 'overdue':
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
            Overdue
          </span>
        );
      default:
        return null;
    }
  };

  const columns: TableColumnsItem[] = [
    {
      key: 'name',
      name: 'Vaccine',
      type: 'text',
    },
    {
      key: 'date',
      name: 'Date Administered',
      type: 'text',
    },
    {
      key: 'nextDue',
      name: 'Next Due',
      type: 'text',
    },
    {
      key: 'status',
      name: 'Status',
      type: 'custom',
      customValue: (row) => getStatusBadge(row.status),
    },
    {
      key: 'administeredBy',
      name: 'Administered By',
      type: 'text',
    },
    {
      key: 'lotNumber',
      name: 'Lot Number',
      type: 'text',
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-medium dark:text-white">Immunizations</h2>
        <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-[#2823F5] dark:bg-[#4F4DFF] hover:bg-[#1f1bb8] dark:hover:bg-[#3F3DFF]">
          <Syringe className="w-4 h-4 mr-2" />
          Add Immunization
        </button>
      </div>

      <MainTable
        data={mockImmunizations}
        columns={columns}
        showSearch={true}
        showAddButton={false}
      />
    </div>
  );
}; 